"use client";

import React, { useEffect } from "react";

const Error = ({ error }: { error: Error }) => {
  useEffect(() => {
    if ((window as any).newrelic) {
      (window as any).newrelic.noticeError(error);
    }
  }, [error]);

  return <div>Something went wrong</div>;
};

export default Error;